export default __webpack_public_path__ + "static/media/togodo-logo-pink.7b2c710f.svg";